import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';

import AddRevenueTypeForm from "./AddRevenueTypeForm";
import { addData, clearQueryResult, queryRevenueType } from "../../actions/valueActions";


const AddRevenueData = ({ id, industry, type, revenueTypes, handleClose }) => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const queryResult = useSelector(state => state.value.queryResult)

    const addRevenueFormAction = () => {
        return (
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    type="submit"
                    disabled={loading}
                    sx={{ textTransform: 'none' }}
                >
                    Request
                </Button>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',  // half of 24
                            marginLeft: '-12px', // half of 24
                            zIndex: 1,
                        }}
                    />
                )}
            </Box>
        )
    }

    const saveRevenueFormAction = () => {
        return (
            <React.Fragment>
                <Button
                    startIcon={<SaveIcon />}
                    type="submit"
                    sx={{ textTransform: 'none' }}
                >
                    Save
                </Button>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    onClick={() => dispatch(clearQueryResult())}
                    sx={{ textTransform: 'none' }}
                >
                    Rerun Request
                </Button>
            </React.Fragment>
        )
    }

    const onSubmitRevenueType = async (values, { setSubmitting }) => {
        values.industry = industry

        setLoading(true)
        let success = false

        const result = await dispatch(queryRevenueType(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitSaveRevenueType = (values) => {
        let revenuePerMultiple = values.revenue_per_multiple
        revenuePerMultiple.lower = revenuePerMultiple.lower.toString().replace(/,/g, '');
        revenuePerMultiple.higher = revenuePerMultiple.higher.toString().replace(/,/g, '');


        values.revenue_per_multiple = revenuePerMultiple;

        dispatch(addData(id, type, 'revenue_type', values))

        handleClose()
    }

    function renderAddRevenueType() {
        // dispatch(clearQueryResult())

        return (
            <AddRevenueTypeForm
                revenueTypes={revenueTypes}
                queryResult={queryResult}
                formActions={addRevenueFormAction}
                formResultActions={saveRevenueFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitRevenueType(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveRevenueType}
                ref={formikRef}
            />
        )
    }

    return (
        <Box>
            {renderAddRevenueType()}
        </Box>
    )
}

export default AddRevenueData